import { type FunctionComponent } from 'react';
import { ReactComponent as BlackStripSVG } from '../../assets/icons/mevo/medicine/tarjapreta.svg';
import IconPattern, { IconProps } from './_IconPattern';

const MedicineBlackStripIcon: FunctionComponent<IconProps> = (props) => {
  return <IconPattern component={BlackStripSVG} variantPlaces={[]} {...props} />;
};

export default MedicineBlackStripIcon;
